import React from 'react';
import { useQuery } from '@apollo/client';
import { useBexApi } from '@shared-ui/bex-api-context';
import { IntersectionTracker } from '@shared-ui/clickstream-analytics-context';
import { UitkList, UitkListItem } from 'uitk-react-list';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkHeading } from 'uitk-react-text';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var __assign = function () {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
                if (Object.prototype.hasOwnProperty.call(s, p))
                    t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

/**
 * @protected
 * Exposing for package internal usage and unit tests only.
 * Do not export queries at the top level of the package.
 */
var __Query = { "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "RelevantContentQuery" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "productIdentifier" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "ProductIdentifierInput" } } }, "defaultValue": undefined, "directives": [] }, { "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "context" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "ContextInput" } } }, "defaultValue": undefined, "directives": [] }], "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "relevantContent" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "productIdentifier" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "productIdentifier" } } }, { "kind": "Argument", "name": { "kind": "Name", "value": "context" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "context" } } }], "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "__typename" }, "arguments": [], "directives": [], "selectionSet": undefined }, { "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "content" }, "arguments": [], "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "InlineFragment", "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "ProductAmenitiesSection" } }, "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "elementID" }, "arguments": [], "directives": [], "selectionSet": undefined }, { "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "title" }, "arguments": [], "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "__typename" }, "arguments": [], "directives": [], "selectionSet": undefined }, { "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "text" }, "arguments": [], "directives": [], "selectionSet": undefined }] } }, { "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "list" }, "arguments": [], "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "__typename" }, "arguments": [], "directives": [], "selectionSet": undefined }, { "kind": "InlineFragment", "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "EGDSBulletedList" } }, "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "__typename" }, "arguments": [], "directives": [], "selectionSet": undefined }, { "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "listItems" }, "arguments": [], "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "InlineFragment", "typeCondition": { "kind": "NamedType", "name": { "kind": "Name", "value": "EGDSTextStandardListItem" } }, "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "__typename" }, "arguments": [], "directives": [], "selectionSet": undefined }, { "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "text" }, "arguments": [], "directives": [], "selectionSet": undefined }] } }] } }] } }] } }] } }] } }, { "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "impressionAnalytics" }, "arguments": [], "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "__typename" }, "arguments": [], "directives": [], "selectionSet": undefined }, { "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "referrerId" }, "arguments": [], "directives": [], "selectionSet": undefined }, { "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "linkName" }, "arguments": [], "directives": [], "selectionSet": undefined }] } }] } }] } }], "loc": { "start": 0, "end": 756, "source": { "body": "\n  query RelevantContentQuery($productIdentifier: ProductIdentifierInput!, $context: ContextInput!) {\n    relevantContent(productIdentifier: $productIdentifier, context: $context) {\n      __typename\n      content {\n        ... on ProductAmenitiesSection {\n          elementID\n          title {\n            __typename\n            text\n          }\n          list {\n            __typename\n            ... on EGDSBulletedList {\n              __typename\n              listItems {\n                ... on EGDSTextStandardListItem {\n                  __typename\n                  text\n                }\n              }\n            }\n          }\n        }\n      }\n      impressionAnalytics {\n        __typename\n        referrerId\n        linkName\n      }\n    }\n  }\n", "name": "GraphQL request", "locationOffset": { "line": 1, "column": 1 } } } };
/**
 * Component to resolve a single Geo Entity and render the result.
 * @param props
 */
var RelevantContent = function (props) {
    var _a, _b, _c;
    var inputs = props.inputs, skipSsr = props.skipSsr;
    var context = useBexApi().context;
    var variables = __assign(__assign({}, inputs), { context: context });
    var _d = useQuery(__Query, { variables: variables, ssr: !skipSsr }), data = _d.data, error = _d.error, loading = _d.loading;
    if (loading || error || !data || !data.relevantContent) {
        return null;
    }
    var _e = data.relevantContent, content = _e.content, impressionAnalytics = _e.impressionAnalytics;
    var title = content.title, list = content.list;
    var relevantAmenity = (React.createElement(React.Fragment, null,
        title && (React.createElement(UitkSpacing, { margin: { blockend: 'two' } },
            React.createElement(UitkHeading, { tag: "h3", size: 6 }, title === null || title === void 0 ? void 0 : title.text))),
        (list === null || list === void 0 ? void 0 : list.__typename) === 'EGDSBulletedList' && ((_a = list === null || list === void 0 ? void 0 : list.listItems) === null || _a === void 0 ? void 0 : _a.length) && (React.createElement(UitkList, { spacing: false, size: 2 }, (_b = list === null || list === void 0 ? void 0 : list.listItems) === null || _b === void 0 ? void 0 : _b.map(function (item, index) { return item.__typename === 'EGDSTextStandardListItem' && React.createElement(UitkListItem, { key: "listitems-".concat(index) }, item.text); })))));
    return impressionAnalytics ? (React.createElement(IntersectionTracker, { trackOnce: true, referrerId: impressionAnalytics.referrerId, linkName: (_c = impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : impressionAnalytics.linkName) !== null && _c !== void 0 ? _c : '' }, relevantAmenity)) : (relevantAmenity);
};
RelevantContent.displayName = 'RelevantContent';

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
/**
 * Specifies the behavior of ALTER, which is used to run Abacus experiments on localization messages.
 */
var AlterMode;
(function (AlterMode) {
    AlterMode["DEBUG"] = "DEBUG";
    AlterMode["NONE"] = "NONE";
    AlterMode["PREVIEW"] = "PREVIEW";
    AlterMode["RELEASED"] = "RELEASED";
})(AlterMode || (AlterMode = {}));
/**
 * Possible aspect ratios of EGDS images
 */
var AspectRatio;
(function (AspectRatio) {
    AspectRatio["FOUR_THREE"] = "FOUR_THREE";
    AspectRatio["ONE_ONE"] = "ONE_ONE";
    AspectRatio["SIXTEEN_NINE"] = "SIXTEEN_NINE";
    AspectRatio["THREE_FOUR"] = "THREE_FOUR";
    AspectRatio["THREE_TWO"] = "THREE_TWO";
    AspectRatio["TWENTY_ONE_NINE"] = "TWENTY_ONE_NINE";
})(AspectRatio || (AspectRatio = {}));
var AuthenticationState;
(function (AuthenticationState) {
    AuthenticationState["ANONYMOUS"] = "ANONYMOUS";
    AuthenticationState["AUTHENTICATED"] = "AUTHENTICATED";
    AuthenticationState["IDENTIFIED"] = "IDENTIFIED";
})(AuthenticationState || (AuthenticationState = {}));
/**
 * Valid device types
 */
var DeviceType;
(function (DeviceType) {
    DeviceType["APP_PHONE"] = "APP_PHONE";
    DeviceType["APP_TABLET"] = "APP_TABLET";
    DeviceType["CHAT_APP"] = "CHAT_APP";
    DeviceType["DESKTOP"] = "DESKTOP";
    DeviceType["MOBILE_PHONE"] = "MOBILE_PHONE";
    DeviceType["MOBILE_TABLET"] = "MOBILE_TABLET";
    DeviceType["VOICE_APP"] = "VOICE_APP";
})(DeviceType || (DeviceType = {}));
/**
 * supported sizes of icons
 */
var IconSize;
(function (IconSize) {
    IconSize["EXTRA_SMALL"] = "EXTRA_SMALL";
    IconSize["LARGE"] = "LARGE";
    IconSize["MEDIUM"] = "MEDIUM";
    IconSize["MEDIUM_LARGE"] = "MEDIUM_LARGE";
    IconSize["SMALL"] = "SMALL";
    IconSize["XLARGE"] = "XLARGE";
})(IconSize || (IconSize = {}));
/**
 * Supported themes of icons. See the prop definitions here: http: // uitk-react.tools.expedia.com/expedia/en_US/components/icons
 */
var IconTheme;
(function (IconTheme) {
    IconTheme["default"] = "default";
    IconTheme["emphasis"] = "emphasis";
    IconTheme["negative"] = "negative";
    IconTheme["positive"] = "positive";
})(IconTheme || (IconTheme = {}));
/**
 * Enum to specify the type for inputId
 */
var IdentifierType;
(function (IdentifierType) {
    IdentifierType["CART_ID"] = "CART_ID";
    IdentifierType["ENTITY_ID"] = "ENTITY_ID";
    IdentifierType["OFFER_ID"] = "OFFER_ID";
    IdentifierType["ORDER_ID"] = "ORDER_ID";
    IdentifierType["PROPERTY_ID"] = "PROPERTY_ID";
})(IdentifierType || (IdentifierType = {}));
/**
 * Privacy tracking user preference. We can retrieve info on if the site allows tracking from Site Info and null can also be used to represent a selection or not
 */
var PrivacyTrackingState;
(function (PrivacyTrackingState) {
    PrivacyTrackingState["CAN_NOT_TRACK"] = "CAN_NOT_TRACK";
    PrivacyTrackingState["CAN_TRACK"] = "CAN_TRACK";
})(PrivacyTrackingState || (PrivacyTrackingState = {}));
/**
 * Enum to specify image width for product image
 */
var ProductImageWidth;
(function (ProductImageWidth) {
    ProductImageWidth["FULL_WIDTH"] = "FULL_WIDTH";
    ProductImageWidth["HALF_WIDTH"] = "HALF_WIDTH";
    ProductImageWidth["QUARTER_WIDTH"] = "QUARTER_WIDTH";
    ProductImageWidth["THIRD_WIDTH"] = "THIRD_WIDTH";
})(ProductImageWidth || (ProductImageWidth = {}));
var ProductLine;
(function (ProductLine) {
    ProductLine["ACTIVITY"] = "ACTIVITY";
    ProductLine["CAR"] = "CAR";
    ProductLine["CRUISE"] = "CRUISE";
    ProductLine["FLIGHT"] = "FLIGHT";
    ProductLine["GROUND_TRANSFER"] = "GROUND_TRANSFER";
    ProductLine["INSURANCE"] = "INSURANCE";
    ProductLine["LODGING"] = "LODGING";
    ProductLine["PACKAGE"] = "PACKAGE";
    ProductLine["PRODUCT_LINE_INVALID"] = "PRODUCT_LINE_INVALID";
    ProductLine["RAIL"] = "RAIL";
    ProductLine["UNRECOGNIZED"] = "UNRECOGNIZED";
})(ProductLine || (ProductLine = {}));
/**
 * Used to highlight or convey information. For example, positive messaging like free cancellation may be green.
 */
var TextTheme;
(function (TextTheme) {
    TextTheme["INVERSE"] = "INVERSE";
    TextTheme["LOYALTY"] = "LOYALTY";
    TextTheme["NEGATIVE"] = "NEGATIVE";
    TextTheme["POSITIVE"] = "POSITIVE";
    TextTheme["PRIMARY"] = "PRIMARY";
    TextTheme["SECONDARY"] = "SECONDARY";
})(TextTheme || (TextTheme = {}));
/**
 * Used to highlight or convey information. For example, Payable amount in the price summary module of the checkout page.
 */
var TextWeight;
(function (TextWeight) {
    TextWeight["BOLD"] = "BOLD";
    TextWeight["MEDIUM"] = "MEDIUM";
    TextWeight["REGULAR"] = "REGULAR";
})(TextWeight || (TextWeight = {}));
//==============================================================
// END Enums and Input Objects
//==============================================================

export { IdentifierType, RelevantContent };
